// PRD §3.3 — Farm request/response schemas shared with mobile.
//
// Reused by backend (Fastify body validation) and mobile (form input).
import { z } from 'zod';
export const FARM_TYPES = ['CARNE', 'LECHE', 'MIXTA'];
export const CreateFarmRequestSchema = z
    .object({
    name: z.string().min(2).max(120),
    type: z.enum(FARM_TYPES),
    municipality: z.string().min(2).max(120),
    province: z.string().max(80).optional(),
    rega_code: z.string().max(40).optional(),
    sigpac_code: z.string().max(40).optional(),
    lat: z.number().min(-90).max(90).optional(),
    lng: z.number().min(-180).max(180).optional(),
})
    .strict();
export const UpdateFarmRequestSchema = CreateFarmRequestSchema.partial().strict();
export const FarmResponseSchema = z.object({
    id: z.string().uuid(),
    rega_code: z.string().nullable(),
    sigpac_code: z.string().nullable(),
    name: z.string(),
    type: z.enum(FARM_TYPES),
    municipality: z.string(),
    province: z.string().nullable(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    owner_id: z.string().uuid(),
    created_at: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=farm.js.map